import { useEffect } from 'react';
import { CONSENT_UPDATED_EVENT, ConsentManager, hasGlobalPrivacyControl } from './Consent';

/** Sets up conversion tracking in Unbounce
 *
 * `useUnbounce` was previously the `UnbounceEmit` component.
 * Why is it setup like this? Great question.
 */
export function useUnbounce(): void {
  useEffect(function setupConversionTracking() {
    let initialized = false;

    const initialize = () => {
      const consent = ConsentManager.get();
      if (initialized || hasGlobalPrivacyControl() || (consent.chosen && !consent.advertising)) {
        return;
      }
      initialized = true;

      window._ubaq = window._ubaq ?? [];
      window._ubaq.push(['trackGoal', 'convert']);
      const ub_script = document.createElement('script');
      ub_script.type = 'text/javascript';
      ub_script.src =
        ('https:' === document.location.protocol ? 'https://' : 'http://') +
        'd3pkntwtp2ukl5.cloudfront.net/uba.js';
      const s: HTMLScriptElement = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(ub_script, s);
    };

    initialize();
    window.addEventListener(CONSENT_UPDATED_EVENT, initialize);
    return () => window.removeEventListener(CONSENT_UPDATED_EVENT, initialize);
  }, []);
}
